import { resolveApiBaseUrl } from "@/api/client"

/** База для socket.io (без trailing slash). */
export function getSocketBaseUrl(): string {
  const base = resolveApiBaseUrl()
  if (base === "/") {
    if (typeof window !== "undefined") {
      return window.location.origin
    }
    return "https://backend.daks.by"
  }
  return base.replace(/\/$/, "")
}
